<template>
	<div>
		<Loader :show="loading" type="inline" />
		<table class="table" v-if="!loading">
			<tr class="table-head">
				<td>Fecha</td>
				<td>Nombre</td>
				<td>Entrada</td>
				<td>Evento</td>
			</tr>

			<tr v-for="item of list" :key="item.id">
				<td>
					<div class="tc">
						<span class="bolder">{{ item.createdAt | moment("DD-MM-YYYY HH:mm") }} </span>
					</div>
				</td>
				<td>
					<div class="tc">
						<span class="bolder">{{ item.client.name }} {{ item.client.lastname }}</span>
						<span class="text-secondary">{{ item.client.document }}</span>
					</div>
				</td>
				<td>
					<div class="tc">
						<span v-if="item.membership && item.membership.membershipType">{{
							item.membership.membershipType.name
						}}</span>
						<span v-if="item.ticket && item.ticket.ticketType">{{ item.ticket.ticketType.name }}</span>
					</div>
				</td>
				<td>
					<div class="tc">
						<span v-if="item.event">{{ item.event.name }}</span>
					</div>
				</td>
			</tr>
		</table>

		<div class="alert p-5 text-center" v-if="!loading && list.length == 0">
			Aún no hay registros
		</div>

		<Pagination :pageData="pagination" @pageChange="pageChange" />
	</div>
</template>

<script>
import gql from "graphql-tag"

export default {
	name: "EventAccessTable",
	props: {
		membershipTypeId: {
			type: String
		}
	},
	data() {
		return {
			list: [],
			loading: true
		}
	},
	beforeMount() {
		this.filters = this.getValidUrlParams()
		this.load()
	},
	methods: {
		load() {
			this.loading = true
			this.$apollo
				.query({
					query: gql`
						query($take: Int, $skip: Int, $search: String, $membershipTypeId: ID) {
							eventAccessCheckIn(
								take: $take
								skip: $skip
								search: $search
								membershipTypeId: $membershipTypeId
							) {
								data {
									id
									createdAt
									event {
										id
										name
									}
									ticket {
										id
										ticketType {
											id
											name
										}
									}
									client {
										id
										name
										lastname
										document
										email
									}
									membership {
										id
										membershipType {
											id
											name
										}
									}
								}
								pageInfo {
									totalItems
								}
							}
						}
					`,
					variables: {
						take: this.pagination.length,
						skip: this.pagination.skip,
						search: this.filters.search,
						membershipTypeId: this.membershipTypeId
					},
					fetchPolicy: "network-only"
				})
				.then(({ data }) => {
					this.list = data.eventAccessCheckIn.data
					this.pagination.pageInfo = data.eventAccessCheckIn.pageInfo
					this.loading = false
				})
				.catch((err) => {
					this.loading = false
				})
		}
	}
}
</script>

<style></style>
